import { useTranslation } from 'react-i18next';

import DateCategory from '~/features/leadDetails/components/Overview/DocumentCenter/Demands/Documents/Date/DateCategory';
import DefaultCategory from '~/features/leadDetails/components/Overview/DocumentCenter/Demands/Documents/Default/DefaultCategory';
import IndividualCategory from '~/features/leadDetails/components/Overview/DocumentCenter/Demands/Documents/Individual/IndividualCategory';
import useDemandedDocuments from '~/features/leadDetails/hooks/useDemandedDocuments';

const Categories = () => {
    const { t } = useTranslation();
    const { demandedDocuments, removeDemandDocument, resetCount, setDemandDocuments, updateDemandDocument } =
        useDemandedDocuments();

    return (
        <div className="flex flex-col gap-3">
            <DateCategory
                title={t('DOCUMENT_DEMANDER.CATEGORIES.PAYSLIPS')}
                documents={demandedDocuments.payslips}
                remove={removeDemandDocument}
                set={setDemandDocuments}
                category={'payslips'}
            />
            <DateCategory
                title={t('DOCUMENT_DEMANDER.CATEGORIES.PAYSLIPS_SIDEJOB')}
                documents={demandedDocuments.payslips_sidejob}
                remove={removeDemandDocument}
                set={setDemandDocuments}
                category={'payslips_sidejob'}
            />
            <DateCategory
                title={t('DOCUMENT_DEMANDER.CATEGORIES.BANK_STATEMENTS')}
                documents={demandedDocuments.bankStatements}
                remove={removeDemandDocument}
                set={setDemandDocuments}
                category={'bankStatements'}
            />
            <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                <DefaultCategory
                    title={t('DOCUMENT_DEMANDER.CATEGORIES.PENSION_CERTIFICATE')}
                    documents={demandedDocuments.pensionCertificate}
                    update={updateDemandDocument}
                    category={'pensionCertificate'}
                />
                <DefaultCategory
                    title={t('DOCUMENT_DEMANDER.CATEGORIES.RESIDENCE_PERMIT')}
                    documents={demandedDocuments.residencePermit}
                    update={updateDemandDocument}
                    category={'residencePermit'}
                />
            </div>
            <DefaultCategory
                title={t('DOCUMENT_DEMANDER.CATEGORIES.CURRENT_LOANS')}
                documents={demandedDocuments.currentLoans}
                update={updateDemandDocument}
                category={'currentLoans'}
            />
            <DefaultCategory
                title={t('DOCUMENT_DEMANDER.CATEGORIES.INDIVIDUAL_LOAN')}
                documents={demandedDocuments.individualLoan}
                update={updateDemandDocument}
                category={'individualLoan'}
                isExpandable={true}
            />
            <IndividualCategory
                // remounts the category so the uncontrolled free-text draft is cleared with the reset
                key={resetCount}
                // we don't need to pass the category here, because it's already defined in the IndividualCategory component
                documents={demandedDocuments.individualDocuments}
                update={updateDemandDocument}
                remove={removeDemandDocument}
            />
        </div>
    );
};

export default Categories;
